module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_5012.3f3d536d.png";